document.addEventListener('alpine:init', () => {
	Alpine.data('variantSelector', () => ({
		activeState: '',
		init() {
			this.sizeDropdown = this.$root.querySelector('#size');
			this.activeState = this.sizeDropdown.value;
		},
		handleClick(size) {
			jQuery(this.sizeDropdown).val(size).trigger('change');
			this.activeState = this.sizeDropdown.value;
		},
	}));
});
